var CandidateJobMatchProfileController = /** @class */ (function () {
    /*@ngInject*/
    function CandidateJobMatchProfileController($rootScope, $scope, $timeout, jobService, jobMatchService, companyService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.jobService = jobService;
        this.jobMatchService = jobMatchService;
        this.companyService = companyService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    CandidateJobMatchProfileController.prototype.$onInit = function () {
        var _this = this;
        //variables
        this.tabs = [];
        this.validTabs = [];
        this.steps = [];
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporateFlag = this.companyService.isCorporateCompany();
        this.isCandidateContactDetailsMissing = false;
        if (this.documentDtoMap) {
            this.candidateDetails = JSON.parse(this.documentDtoMap);
        }
        if (this.context == 'candidateCard') {
            this._loadValidTabs();
            this.activeTab = this.validTabs.findIndex(function (tab) { return tab.isActive == true; });
        }
        else if (this.context !== 'candidateJobComparison') {
            this.getEnabledWorkflowSteps(function () {
                _this.getCandidateJobMatchCardInfo(function () {
                    _this._checkAvailableFeedbackReports(function () {
                        _this._initFileNames();
                        _this._loadTabs();
                    });
                });
            });
        }
        else if (this.context === "candidateJobComparison" && !this.jobMatchId) {
            this._loadTabs();
        }
        else {
            this.getCandidateJobMatchCardInfo(function () {
                _this._initFileNames();
                _this._loadTabs();
            });
        }
    };
    CandidateJobMatchProfileController.prototype.getEnabledWorkflowSteps = function (successCallback) {
        var _this = this;
        this.jobService.getEnabledWorkflowSteps(this.jobId, function (data) {
            _this.enabledWorkflowSteps = data;
            _this.steps.push("Outreach");
            angular.forEach(_this.enabledWorkflowSteps, function (step, key) {
                _this.steps.push(step);
            });
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CandidateJobMatchProfileController.prototype.getCandidateJobMatchCardInfo = function (successCallback) {
        var _this = this;
        this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, function (data) {
            _this.jobMatchInfo = data;
            _this.jobMatchInfo.name = data.firstName + ' ' + data.lastName;
            _this.jobLocation = "";
            if (_this.jobMatchInfo.jobLocation !== null) {
                _this.jobLocation = _this.jobService.getParsedJobLocationText(_this.jobMatchInfo.jobLocation, false);
            }
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchProfileController.prototype._checkAvailableFeedbackReports = function (successCallback) {
        var _this = this;
        this.jobMatchService.getFeedbackReportsAvailability(this.jobMatchId, this.companyId, function (data) {
            var feedbackReports = data.feedbackReportsAvailability;
            _this.isRecruiterScreeningFeedbackAvailable = feedbackReports["recruiterScreeningFeedbackReport"];
            _this.isPhoneScreenFeedbackAvailable = feedbackReports["phoneScreenFeedbackReport"];
            _this.isInterviewFeedbackAvailable = feedbackReports["interviewFeedbackReport"];
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchProfileController.prototype._initFileNames = function () {
        this.outreachFeedbackFileName = this.generalFileName + '-outrachFeedback' + '.pdf';
        this.generalFileName = this.jobMatchInfo.name + '-' + this.jobMatchInfo.jobMatchTitle;
        this.taFileName = this.generalFileName + '-' + this.jobMatchInfo.techAssessmentName + '.pdf';
        this.vaFileName = this.generalFileName + '-' + this.jobMatchInfo.valueAssessmentName + '.pdf';
        this.recruiterScreeningFileName = this.generalFileName + '-RecruiterScreening' + '.pdf';
        this.phoneScreeningFileName = this.generalFileName + '-PhoneScreen' + '.pdf';
        this.interviewFeedbackFileName = this.generalFileName + '-InterviewFeedback' + '.pdf';
    };
    CandidateJobMatchProfileController.prototype._loadTabs = function () {
        if (this.context !== 'candidateJobComparison') {
            this._loadWorkflowSteps();
        }
        this._loadValidTabs();
        this.activeTab = this.validTabs.findIndex(function (tab) { return tab.isActive == true; });
    };
    CandidateJobMatchProfileController.prototype._loadWorkflowSteps = function () {
        this.sectionalReport = false;
        if (this.jobMatchInfo.isSharedRequisition && !this.isCorporateFlag) {
            this.sectionalReport = true;
        }
        if (this.jobMatchInfo.outreachReport) {
            this.outreachReportUrl = "api/jobmatch/outreachFeedbackReport/" + this.jobMatchId + "?companyId=" + this.companyId;
            this.tabs.push({ name: "Outreach", step: "Outreach", fileName: this.outreachFeedbackFileName, url: this.outreachReportUrl, isLoading: false });
        }
        if (!_.isNull(this.jobMatchInfo.techAssessmentPdfReportURL) && !_.isNull(this.jobMatchInfo.techAssessmentScore) && this.jobMatchInfo.techAssessmentScore.toString() != '') {
            this.taUrl = 'api/candidate/candidatepdfreport?filepath=' + this.jobMatchInfo.techAssessmentPdfReportURL + '&testinvitationid=' + this.jobMatchInfo.techAssessmentInvitationId + '&sectional=' + this.sectionalReport;
            this.tabs.push({ name: 'Tech Assessment', step: 'Tech Assessment', fileName: this.taFileName, url: this.taUrl, isLoading: false });
        }
        if (!_.isNull(this.jobMatchInfo.valueAssessmentPdfReportURL) && !_.isNull(this.jobMatchInfo.valueAssessmentScore) && this.jobMatchInfo.valueAssessmentScore.toString() != '') {
            this.vaUrl = 'api/candidate/candidatepdfreport?filepath=' + this.jobMatchInfo.valueAssessmentPdfReportURL + '&testinvitationid=' + this.jobMatchInfo.valueAssessmentInvitationId + '&sectional=' + this.sectionalReport;
            this.tabs.push({ name: "Value Assessment", step: 'Value Assessment', fileName: this.vaFileName, url: this.vaUrl, isLoading: false });
        }
        if (this.isRecruiterScreeningFeedbackAvailable) {
            this.recruiterScreeningFeedbackUrl = "api/jobmatch/getscreeningfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
            this.tabs.push({ name: "Recruiter Screening", step: 'Recruiter Screening', fileName: this.recruiterScreeningFileName, url: this.recruiterScreeningFeedbackUrl, isLoading: false });
        }
        if (this.isPhoneScreenFeedbackAvailable) {
            this.phoneScreenFeedbackUrl = "api/jobmatch/getphonescreenfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
            this.tabs.push({ name: "Phone Screen(s)", step: 'Phone Screen', fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, isLoading: false });
        }
        if (this.isInterviewFeedbackAvailable) {
            this.interviewFeedbackUrl = "api/jobmatch/getinterviewfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
            this.tabs.push({ name: "Interview(s)", step: "Interview", fileName: this.interviewFeedbackFileName, url: this.interviewFeedbackUrl, isLoading: false });
        }
    };
    CandidateJobMatchProfileController.prototype._loadValidTabs = function () {
        var _this = this;
        var candidateProfileTab = { name: 'Profile', step: 'Profile' };
        if (this.context == 'candidateJobComparison') {
            this.validTabs.push(candidateProfileTab);
            this.validTabs.push({ name: 'Job Profile', step: 'Job Profile' });
            this.validTabs.push({ name: 'Compare', step: 'Compare', isActive: true });
        }
        else if (this.context == 'candidateJobMatchCard') {
            candidateProfileTab.isActive = true;
            this.validTabs.push(candidateProfileTab);
            this.validTabs.push({ name: 'Job Profile', step: 'Job Profile' });
            this.validTabs.push({ name: 'Compare', step: 'Compare' });
        }
        else if (this.context == 'candidateCard') {
            candidateProfileTab.isActive = true;
            this.validTabs.push(candidateProfileTab);
        }
        this.validTabs.push({ name: 'Documents', step: 'Documents' });
        if (this.candidateDetails && (this.candidateDetails.isNotification || this.candidateDetails.isLogin)) {
            this.validTabs.map(function (tab) {
                tab.isActive = tab.name === 'Documents';
            });
        }
        if (this.context != 'candidateCard') {
            angular.forEach(this.steps, function (step, index) {
                angular.forEach(_this.tabs, function (tab, tabIndex) {
                    if (tab.step == step) {
                        _this.validTabs.push(tab);
                    }
                });
            });
            if (this.steps.length == 0) {
                if (this.jobMatchInfo.outreachReport) {
                    this.outreachReportUrl = "api/jobmatch/outreachFeedbackReport/" + this.jobMatchId + "?companyId=" + this.companyId;
                    this.validTabs.push({ name: "Outreach", step: "Outreach", fileName: this.outreachFeedbackFileName, url: this.outreachReportUrl, isLoading: false });
                }
            }
        }
    };
    return CandidateJobMatchProfileController;
}());
CandidateJobMatchProfileController.$inject = ['$rootScope', '$scope', '$timeout', 'jobService', 'jobMatchService', 'companyService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './candidate-job-match-profile.html;
import * as TEMPLATE from 'raw-loader!./candidate-job-match-profile.html';
export var CandidateJobMatchProfileComponent = {
    selector: 'candidateJobMatchProfile',
    component: {
        bindings: {
            jobMatchId: '@',
            jobId: '@',
            candidateId: '@',
            feedbackUserIdsList: '@',
            context: '@',
            candidateType: '@',
            candidateDetails: '<',
            documentDtoMap: '@',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: CandidateJobMatchProfileController,
        // templateUrl: 'app/shared/jobMatchActions/candidateJobMatchProfile/candidate-job-match-profile.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=candidate-job-match-profile.component.js.map